import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import AppRouter from './routing/AppRouter.jsx'
import { queryClient } from './api/queryClient.js'

// The 100ms SDK reads `process.env.REACT_SDK_VERSION` at render, but the browser
// has no Node `process` global. Provide a minimal shim before the lazy 100ms
// meeting chunk ever evaluates (it's code-split, so this always runs first).
if (typeof globalThis.process === 'undefined') {
  globalThis.process = { env: {} }
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  </StrictMode>,
)
